/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'feedback-collector.anonymous': '此反馈将匿名提交。Atlassian 将无法就此反馈直接与您联系',
  'feedback-collector.anonymous.title': '匿名反馈',
  'feedback-collector.can-be-contacted.label': '是的，Atlassian 团队可以联系我，以便了解我的体验，进而改进 Atlassian 产品和服务。我确认 <a>Atlassian 隐私政策</a>。',
  'feedback-collector.cancel-button.label': '取消',
  'feedback-collector.default.custom.textarea.label': '请告诉我们您的想法。',
  'feedback-collector.enrol-in-research.label': '我想参加产品调研',
  'feedback-collector.feedback-title': '分享您的想法',
  'feedback-collector.form.bug.label': '描述缺陷或问题',
  'feedback-collector.form.comment.label': '告诉我们您的想法',
  'feedback-collector.form.empty.label': '选择一个选项',
  'feedback-collector.form.question.label': '您想知道什么？',
  'feedback-collector.form.suggestion.label': '告诉我们您想改进的方面',
  'feedback-collector.option.bug.label': '报告缺陷',
  'feedback-collector.option.comment.label': '发表评论',
  'feedback-collector.option.default.label': '选择反馈',
  'feedback-collector.option.default.placeholder': '选择一条',
  'feedback-collector.option.question.label': '提出问题',
  'feedback-collector.option.suggestion.label': '提供改进建议',
  'feedback-collector.required.fields.summary': '必填字段标有星号',
  'feedback-collector.submit-button.label': '发送反馈',
  'feedback-collector.success-flag.description': '您宝贵的反馈意见可以帮助我们不断改进产品。',
  'feedback-collector.success-flag.title': '谢谢！',
  'feedback-collector.summary-placeholder': '告诉我们您的想法',
  'proforma-form-builder.feedback-icon-label': '反馈',
  'proforma-form-builder.give-feedback': '提供反馈'
};